import { createSelector, createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "layout",
  initialState: {
    isScrollDown: false,
    isScrollUp: true,
    isExtendSidebar: true,
  },
  reducers: {
    onScrollUp: (layout) => {
      layout.isScrollDown = false;
      layout.isScrollUp = true;
    },
    onScrollDown: (layout) => {
      layout.isScrollDown = true;
      layout.isScrollUp = false;
    },
    toggleSidebar: (layout, action) => {
      layout.isExtendSidebar = action.payload;
    }
  },
});

export const { onScrollUp, onScrollDown, toggleSidebar } = slice.actions;

export default slice.reducer;

export const getScrollUp = createSelector(
  state => state.layout.isScrollUp,
  value => value
)
export const getScrollDown = createSelector(
  state => state.layout.isScrollDown,
  value => value
)
export const getExtendSidebar = createSelector(
  state => state.layout.isExtendSidebar,
  value => value
)

